//src/pages/Dashboard.jsx

import RoleMenu from "../components/RoleMenu";
import { getUser } from "../components/AuthService";
import MainLayout from "../layouts/MainLayout";

function Dashboard() {
  const user = getUser();

  return (
    <MainLayout>
      <div className="dash-welcome">
        <div className="dash-welcome-card">
          <h2>Welcome, {user?.name || "User"}</h2>
          <dl className="dash-meta">
            <div className="dash-meta-item">
              <dt>Role</dt>
              <dd>{user?.role || "—"}</dd>
            </div>
            <div className="dash-meta-item">
              <dt>Email</dt>
              <dd>{user?.email || "—"}</dd>
            </div>
            <div className="dash-meta-item">
              <dt>Designation</dt>
              <dd>{user?.designation || "—"}</dd>
            </div>
          </dl>
        </div>
        <RoleMenu />
      </div>
    </MainLayout>
  );
}

export default Dashboard;
